<template>
  <div>
    <div class="text-center">
      <img src="../../../public/images/sespa/brasaoSespa.png" width="300" />
      <div class="mt-3">
        <strong>GOVERNO DO ESTADO DO PARÁ</strong><br />
        <strong>SECRETARIA DE ESTADO DE SAÚDE PÚBLICA</strong><br />
        <strong>DEPARTAMENTO DE ADMINISTRAÇÃO E SERVIÇOS - DAS</strong><br />
        <strong>DIVISÃO DE SERVIÇOS GERAIS - DSG</strong><br />
      </div>
    </div>
    <br />
    <table>
      <tr>
        <td class="p-2">
          <strong> PROTOCOLO: {{ obj.id }}</strong>
        </td>
      </tr>
      <tr>
        <td class="p-2">
          <strong> SETOR: {{ obj.sector }}</strong>
        </td>
      </tr>
      <tr v-if="obj.requester">
        <td class="p-2">
          <strong> SOLICITANTE: {{ obj.requester }}</strong>
        </td>
      </tr>
      <tr>
        <td class="p-2">
          <strong> SOLICITAÇÃO: {{ obj.description }}</strong>
        </td>
      </tr>
      <tr>
        <td class="p-2">
          <strong> SERVIÇO EXECUTADO: </strong><br />
          <div class="p-2">
            <input type="radio" id="html" name="exebuted" value="sim" />
            <label for="html">SIM</label><br />
            <input type="radio" id="css" name="exebuted" value="nao" />
            <label for="css">NÃO</label><br />
          </div>
        </td>
      </tr>
      <tr>
        <td class="p-2">
          <strong>DESCRIÇÃO DO SERVIÇO: </strong><br />
          <div class="p-5">
            <div class="borda-top pt-5"></div>
            <div class="borda-top pt-5"></div>
            <div class="borda-top pt-5"></div>
          </div>
        </td>
      </tr>
      <tr>
        <div class="pt-6 pl-6 pr-6">
          <div class="grid">
            <div class="col-6 text-center">
              <div class="borda-top"></div>
              <div class="pt-4">
                <b>Responsável pela execução do serviço</b>
              </div>
            </div>
            <div class="col-6 text-center">
              <div class="borda-top"></div>
              <div class="pt-4">
                <b
                  >Setor beneficiado atestado<br />
                  Carimbo e Assinatura</b
                >
              </div>
            </div>
          </div>
        </div>
      </tr>
      <tr>
        <td class="p-2">
          <strong>OBSERVAÇÃO: </strong><br />
          <div class="borda-top pt-5"></div>
          <div class="borda-top pt-5"></div>
          <div class="borda-top pt-5"></div>
        </td>
      </tr>
    </table>
    <div class="p-grid">
      <div class="p-col-3 p-p-4">
        <strong>
          DATA:
          {{ $DateTime.formatarDate(new Date()) }}</strong
        >
        <br /><br />
      </div>
      <div class="p-col-6 p-pt-6">
        <br /><br />
        <div class="borda-top p-text-center p-pt-2">
          <strong>Chefe da DSG/DAS/SESPA</strong>
        </div>
      </div>
      <div class="p-col-3"></div>
    </div>
    <div class="text-center">
      <p>
        Coordenação de Tecnologia e Informática em Saúde - CTIS <br />
        End: Tva. Lomas Valentinas, 2190, Bairro Marco, CEP: 66.095=492, Belém,
        Pará <br />
        Contato: +55, 91 4006-4399 | 40064328 <b><u>www.saude.pa.gov.br</u></b>
      </p>
    </div>
  </div>
</template>

<script>
import Solicitation from "../../models/internal/solicitation";
import SolicitationService from "../../service/solicitation/solicitation_service";
export default {
  data() {
    return {
      service: new SolicitationService(),
      obj: new Solicitation(),
    };
  },
  created() {
    this.findById();
  },
  methods: {
    findById() {
      this.service
        .findById(this.$route.query.solicitacao_id)
        .then((data) => {
          this.obj = data;
          setTimeout(() => window.print(), 2000);
        })
        .catch((error) => this.$msgErro(error));
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  font-size: 48px;
}
.borda-top {
  border-top: 1px solid black;
}
.borda-bottom {
  border-bottom: 1px solid black;
}
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
}
table {
  width: 100%;
}
</style>
